import { create } from 'zustand';

const useProductShowStore = create(set => ({
  productStock: null,
  productBasketQuantity: null,

  setProductStock: productStock => set({ productStock }),
  setProductBasketQuantity: productBasketQuantity =>
    set({ productBasketQuantity }),

  selectedStore: null,
  storeStock: null,
  locationId: null,

  setSelectedStore: selectedStore => set({ selectedStore }),
  setStoreStock: storeStock => set({ storeStock }),
  setLocationId: locationId => set({ locationId }),

  showBackOrderMessage: false,
  setShowBackOrderMessage: showBackOrderMessage =>
    set({ showBackOrderMessage }),

  showBackOrderModal: false,
  backOrderSuccessCallback: null,
  openBackOrderModal: callback =>
    set({
      showBackOrderModal: true,
      backOrderSuccessCallback: callback,
    }),
  closeBackOrderModal: () =>
    set({
      showBackOrderModal: false,
      backOrderSuccessCallback: null,
    }),

  isAddingToBasket: false,
  setIsAddingToBasket: isAddingToBasket => set({ isAddingToBasket }),

  quantitySelectorInput: 1,
  quantitySelectorError: null,
  quantitySelectorActions: {
    setQuantitySelectorInput: quantity =>
      set({ quantitySelectorInput: +quantity }),
    setError: (quantity, error) =>
      set({
        quantitySelectorInput: +quantity,
        quantitySelectorError: error,
      }),
    clearQuantitySelectorError: () =>
      set({
        quantitySelectorError: null,
      }),
  },
}));

export default useProductShowStore;
